import { PP2ThemeProvider, useThemedValueSwitch } from '@tq/ui-components';
import React from 'react';

import { NiGlobalStyle, TqGlobalStyle } from 'styles';
import { getTheme } from './getTheme';
import { theme } from '../../tools';

const ApplyGlobalStyle = () => {
  const { isTQ } = useThemedValueSwitch();

  return isTQ ? <TqGlobalStyle /> : <NiGlobalStyle />;
};

export const ThemeProvider: React.FC = ({ children }) => {
  return (
    <PP2ThemeProvider locale={getTheme(theme)}>
      <ApplyGlobalStyle />
      {children}
    </PP2ThemeProvider>
  );
};
